/* globals jQuery */
import 'fitvids.1.1.0'
import 'flexslider'
import 'slick-carousel'
//import 'magnific-popup'
import objectFitImages from 'object-fit-images';

import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion.js'
import appfolioListings from './appfolio-listings.js'

(($) => {

    $.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion
    $.fn.appfolioListings = appfolioListings

    //polyfill for IE object-fit on images - https://github.com/fregante/object-fit-images
    var $objectFit = $('img.js-object-fit');
    objectFitImages($objectFit);

    // Main hero slideshow
    var $sliderItemTotal = $(".slideshow__controls .count .total"),
		$sliderItemCurrent = $(".slideshow__controls .count .current");

	function slideCounter(item){
		$sliderItemCurrent.text( "0" + (item.currentSlide + 1) );
		$sliderItemTotal.text( "0" + item.count );
	}
    $('.slideshow.flexslider').flexslider({
        initDelay: 5000,
        animationLoop: true,
        controlNav: false,
		customDirectionNav: '.slideshow__controls a',
		start: function(item){
			slideCounter(item);
		},
		after: function(item){
		    slideCounter(item);
		}
    });

    // Make nav menu nice & responsive
    $('nav.main-nav').responsiveNav({
        navType: 'dropdown', //default option for dropdown type use 'dropdown'
        closeOnOutsideClick: false, //set to false if using dropdown type
        showTabsOnFocus: true,
    });

    // Responsive Videos
    $('.rtecontent').fitVids();

    // Accordions
    $('dl.accordion').accordion();

    // GALLERY COUNTER
    $('.slideshow-gallery__image').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
         $('.gallery-item-current').text( "0" + ( (currentSlide ? currentSlide : 0) + 1) );
    });

    //Gallery Slideshow IMAGES (no captions)
    $('.js-slides-image').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        variableWidth: true,
		arrows: true,
		prevArrow: $('.slideshow-gallery__pages .slick-prev'),
		nextArrow: $('.slideshow-gallery__pages .slick-next'),
		centerMode: true,
	});
	
	//Gallery Slideshow IMAGES (for with captions)
	$('.js-slides-image-content').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        variableWidth: true,
		arrows: true,
		prevArrow: $('.slideshow-gallery__pages .slick-prev'),
		nextArrow: $('.slideshow-gallery__pages .slick-next'),
		centerMode: true,
		asNavFor: '.slideshow-gallery__content'
    });

    //Gallery Slideshow - CAPTION slider
    $('.js-slides-content').slick({
        arrows: false,
        fade: true,
        asNavFor: '.slideshow-gallery__image'
      });

})(jQuery)
